/*───────────────────────────────────────────────────────────────
 🌐 Project: Ring2All Platform
 🧑‍💻 Author: Rodrigo Cuadra
 🏢 Company: Ring2All LLC
 📄 File: hooks/useRoleProfilesColumns.ts
 🗓️ Created: 2025-01-XX
 🧩 Description:
    Hook for generating role profiles DataGrid columns.
────────────────────────────────────────────────────────────────*/

import { useMemo } from 'react';
import { useI18n } from '../../../hooks/useI18n';

export function useRoleProfilesColumns() {
  const { t, refreshKey, i18n } = useI18n();

  const availableColumns = useMemo(() => {
    return [
      { key: 'name', label: t('profiles.profileName'), visible: true, sortable: true },
      { key: 'description', label: t('profiles.description'), visible: true, sortable: true },
      { key: 'usersCount', label: t('profiles.usersCount'), visible: true, sortable: true },
      { key: 'created_at', label: t('profiles.created'), visible: true, sortable: true },
      { key: 'updated_at', label: t('profiles.modified'), visible: true, sortable: true },
      { key: 'permissions', label: t('profiles.permissions'), visible: true, sortable: false },
      { key: 'actions', label: t('profiles.actions.label'), visible: true, sortable: false }
    ];
  }, [t, i18n.language, refreshKey]);

  return availableColumns;
}

